export default __webpack_public_path__ + "static/media/description.8fb679f6.svg";